import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { PersonTypes } from "../../utils";

export const PersonDropDown = ({ value, isMulti = false, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    setList(PersonTypes);
    return () => {
      setList();
    };
  }, []);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? null}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};
